import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isFreeUser } from '../../services/entity/user/user-service';
import { useUser } from '../../contexts/UserContext';
import { JournalLeftPanel } from './components/left-panel/JournalLeftPanel';
import { JournalPatternPanel } from './components/pattern-panel/JournalPatternPanel';
import { PatternSetupProvider, usePatternSetup } from '../../contexts/PatternSetupContext';
import { JournalRightPanel } from './components/right-panel/JournalRightPanel';
import { JournalProvider } from "../../contexts/JournalContext";
import { JournalMainPanel } from "./components/main-panel/JournalMainPanel";

export const JournalPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
    if (isFreeUser(user)) {
      navigate('/demo/live');
    }
  }, [user]);

  return (
    <JournalProvider>
      <PatternSetupProvider>
        <div id='production-page' className='flex w-full h-full'>
          <JournalPageView />
        </div>
      </PatternSetupProvider>
    </JournalProvider>
  );
};

const JournalPageView = () => {
  const { isPatternPanelOpened } = usePatternSetup();

  return (
    <div className="flex w-full">
      {
        process.env.REACT_APP_PRODUCTION_MODE !== "3" &&
          <div className='flex w-2/12 h-full'>
            <JournalLeftPanel />
          </div>
      }
      <div className="flex-1 transition-all duration-500">
        <JournalMainPanel/>
      </div>
      <div className={`transition-all duration-500 ${isPatternPanelOpened ? 'w-3/12' : 'w-0'}`}>
        <JournalPatternPanel/>
      </div>
      <div className='flex w-2/12 h-full'>
        <JournalRightPanel/>
      </div>
    </div>
  );
};
